module.exports = "/images/domicilio.svg";